import { DEFAULT_POST_LOGIN_HASH } from "../auth/adminAccess";

export function sanitizeReturnTo(returnTo, defaultPath = DEFAULT_POST_LOGIN_HASH) {
  if (returnTo === undefined || returnTo === null) {
    return defaultPath;
  }

  const trimmed = String(returnTo).trim();
  if (!trimmed) {
    return defaultPath;
  }

  const lower = trimmed.toLowerCase();

  if (
    lower.includes("://") ||
    lower.startsWith("//") ||
    lower.startsWith("javascript:") ||
    lower.startsWith("data:")
  ) {
    return defaultPath;
  }

  if (trimmed.startsWith("#/")) {
    return trimmed;
  }

  if (!trimmed.startsWith("/")) {
    return defaultPath;
  }

  return trimmed;
}

export function applyReturnToNavigation(returnTo, navigate) {
  const destination = sanitizeReturnTo(returnTo);

  if (destination.startsWith("#/")) {
    navigate("/", { replace: true });
    window.location.hash = destination;
    return;
  }

  navigate(destination, { replace: true });
}
